import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chevron-double-right-icon',
  templateUrl: 'chevron-double-right-icon.component.html'
})
export class ChevronDoubleRightIconComponent {
  constructor() {}
}
